import router from "./router";
import store from "./store";
import NProgress from "nprogress"; // progress bar
import {
  getLoginStatus,
  getRandom,
  getBlind,
  getProName,
  getProStatus,
  getProjectId,
  getProDetail
} from "@/utils/auth"; // get token from cookie
import "nprogress/nprogress.css"; // progress bar style
import getPageTitle from "@/utils/get-page-title";
import { constantRoutes } from "@/router";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ["/login", "/auth-redirect", "/findPwd"]; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // console.log(router)
  // console.log(to)
  // console.log(from)
  // start progress bar
  NProgress.start();

  // set page title
  document.title = getPageTitle(to.meta.title);

  // determine whether the user has logged in
  // const hasToken = getToken()
  const hasToken = sessionStorage.getItem('iwrs_token');
  if (hasToken) {
    if (to.path === "/login") {
      // if is logged in, redirect to the home page
      next({ path: "/" });
      NProgress.done(); // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else if (
      to.path.lastIndexOf("/platform") === -1 &&
      to.path.lastIndexOf("/infoMation") === -1
    ) {
      const admin = store.getters.name;
      const roleName = store.getters.roleName;
      const routerRoles = store.getters.routerRoles;
      if (!admin) {
        await store.dispatch("user/getInfo");
      }
      if (!roleName || !routerRoles) {
        await store.dispatch("user/getRole", getProjectId());
      }
      const proName = getProName(); // 项目名称
      const randomType = getRandom(); // 随机类型
      const blindType = getBlind(); // 盲太类型
      const proStatus = getProStatus(); // 项目类型
      const projectInfo = getProDetail();
      const routerRoless = store.getters.routerRoles;
      const isAdmin = store.getters.isAdmin;
      const routerdiy = [];
      let routerRolessCopy = [];
      if (!isAdmin) {
        //同步项目隐藏访视管理
        if (projectInfo.is_synchro_edc) {
          delete routerRoless["访视管理"];
          if(store.getters.roleName === '项目管理员'){
            routerRoless["受试者配置"] = [''];
          }
        }
        for (let keyys in routerRoless) {
          if (routerRoless[keyys].length) {
            routerRolessCopy.push(keyys);
          }
        }
        if (blindType !== "双盲") {
          delete routerRoless["揭盲管理"];
        }
        constantRoutes.map(item => {
          const keys = Object.keys(routerRoless);
          // console.log("---->", projectInfo);
          if (keys.lastIndexOf(item.key) > -1) {
            if (item.path.lastIndexOf("/platform") > -1) {
              item.hidden = true;
            } else {
              if (item.path.lastIndexOf("/infoMation") === -1) {
                if (item.meta) {
                  item.meta.proTitle = proName;
                }
                if (
                  item.path === "/blindFundus" &&
                  item.key &&
                  routerRolessCopy.indexOf(item.key) !== -1
                ) {
                  item.hidden = randomType === "动态随机";
                } else if (
                  item.path === "/urgent" &&
                  item.key &&
                  routerRolessCopy.indexOf(item.key) !== -1
                ) {
                  item.hidden = blindType === "单盲" || blindType === "开放";
                  //  else if (item.path === '/unblinding') {
                  //  item.hidden = (blindType === '单盲' || blindType === '开放' || proStatus === '项目创建中' || proStatus === '项目进行中')
                } else if (item.path === "/test") {
                  item.hidden = randomType === "静态随机";
                } else if (
                  item.key &&
                  routerRolessCopy.indexOf(item.key) === -1
                ) {
                  return true;
                }
                {
                  item.hidden = false;
                }
              }
            }
            routerdiy.push(item);
          } else {
            if (item.path.lastIndexOf("/homepage") > -1) {
              item.hidden = false;
              routerdiy.push(item);
            }
          }
        });
      } else {
        constantRoutes.map(item => {
          if (item.path.lastIndexOf("/platform") > -1) {
            item.hidden = true;
          } else {
            if (item.path.lastIndexOf("/infoMation") === -1) {
              if (item.meta) {
                item.meta.proTitle = proName;
              }
              if (item.path === "/blindFundus") {
                item.hidden = randomType === "动态随机";
              } else if (item.path === "/urgent") {
                item.hidden = blindType === "单盲" || blindType === "开放";
              } else if (item.path === "/unblinding") {
                item.hidden =
                  blindType === "单盲" ||
                  blindType === "开放" ||
                  proStatus === "项目创建中" ||
                  proStatus === "项目进行中";
              } else if (item.path === "/test") {
                item.hidden = randomType === "静态随机";
              } else if (item.path === "/visit" && projectInfo.is_synchro_edc) {
                return false;
              } else if (
                item.path === "/subjectConfig" &&
                !projectInfo.is_synchro_edc
              ) {
                return false;
              } else {
                item.hidden = false;
              }
            }
          }
          // console.log(item);
          routerdiy.push(item);
        });
      }
      await store.dispatch("permission/setAsyncRoutes", routerdiy);
      next();
    } else {
      const admin = store.getters.name;
      const roleName = store.getters.roleName;
      console.log(admin)
      if (!admin) {
        await store.dispatch("user/getInfo");
      }
      if (roleName) {
        await store.dispatch("user/getRole", null);
      }
      const router = constantRoutes.map(item => {
        if (item.path.lastIndexOf("/platform") > -1) {
          item.hidden = false;
          return item;
        } else {
          item.hidden = true;
          return item;
        }
      });
      await store.dispatch("permission/setAsyncRoutes", router);
      next();
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
